export enum TypeEnum {
    Input = 1,
    Number = 2,
    TextArea = 3,
    Checkbox = 4,
    RadioButton = 5,
    Dropdown = 6
}

export enum AuditStatusEnum {
    Completed = 1,
    NotCompleted = 2
}
